module.exports = __webpack_public_path__ + "4331bbffaf14d8075926a7317c531185.fbx";